module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"parentProduct":"Product","childProduct":"Recommendation","edit":"Edit","delete":"Delete","undefinedProduct":"Loading information..."},"es":{"parentProduct":"Producto","childProduct":"Recomendación","edit":"Editar","delete":"Eliminar","undefinedProduct":"Cargando información..."}}')
  delete Component.options._Ctor
}
